import { useSnackbar } from 'notistack';
import { useEffect, useRef, useState } from 'react';
import { UseFormReset, UseFormSetValue } from 'react-hook-form';
import {
  getConstructionExpectedDates,
  updateConstructionExpectedDates
} from '../../../../apicalls/process';
import {
  TAddSiteProcessForm,
  TSiteProcessDetailData
} from '../../../../types/process';

export type TProps = {
  setIsOpen: React.Dispatch<boolean>;
  constructId: number;
  setValue: UseFormSetValue<any>;
  reset: UseFormReset<any>;
  isOpen: boolean;
  setHasExpectedDays?: React.Dispatch<boolean>;
};

export const useHooks = (props: TProps) => {
  const {
    setIsOpen,
    constructId,
    setValue,
    reset,
    isOpen,
    setHasExpectedDays
  } = props;

  // 多重送信対策用フラグ
  const isSubmitable = useRef(false);
  const { enqueueSnackbar } = useSnackbar();

  // 終了日付管理用ステート（DatePicker の `toDate` 用）
  const [endDate, setEndDate] = useState<string>('');

  const submit = async (form: TAddSiteProcessForm) => {
    if (!isSubmitable.current) return;
    isSubmitable.current = false;
    try {
      // 予定日の更新処理
      await updateConstructionExpectedDates(
        constructId,
        form.start_date, // 開始日
        form.end_date // 終了日
      );
      setHasExpectedDays?.(true);
      enqueueSnackbar('工事期間の設定に成功しました', { variant: 'success' });
      setIsOpen(false);
    } catch (error) {
      enqueueSnackbar('工事期間の設定に失敗しました', { variant: 'error' });
    }
  };

  // キャンセル処理
  const cancelSubmit = () => {
    setIsOpen(false);
  };

  // 終了日付変更ハンドラ
  const handleChangeEndDatePicker = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setEndDate(e.target.value);
  };

  // モーダル表示時の初期化処理
  useEffect(() => {
    if (isOpen) {
      isSubmitable.current = true;
      setEndDate('');
      reset({
        start_date: null,
        end_date: null
      });

      // 予定日を取得してフォームに反映
      getConstructionExpectedDates(constructId)
        .then(res => {
          if (!res || typeof res !== 'object') return;
          setValue('start_date', res.expected_contract_date || null);
          if (res.expected_end_date) {
            setValue('end_date', res.expected_end_date);
            setEndDate(res.expected_end_date);
          } else {
            setValue('end_date', null);
            setEndDate('');
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  }, [isOpen]);

  return {
    submit,
    cancelSubmit,
    endDate,
    handleChangeEndDatePicker
  };
};
